// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"g","attrs":{"id":"text-style"},"children":[{"tag":"path","attrs":{"id":"stroke1","stroke":"props.strokeColor1","d":"M5 3H12M12 3H19M12 3V21","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}},{"tag":"path","attrs":{"id":"stroke2","stroke":"props.strokeColor2","d":"M16.5 15.5L19 18L16.5 20.5M7.5 15.5L5 18L7.5 20.5","strokeLinecap":"square","strokeWidth":"props.strokeWidth"}}]}]};

const TextStyleIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'text-style',
    ref,
    icon: element,
  },
));

TextStyleIcon.displayName = 'TextStyleIcon';

export default TextStyleIcon;
